<template>
    <section class="objective-section">
        <header class="objective-section__header">
            <p class="objective-section__title typographies-paragraph-large-bold">
                <slot name="icon"></slot>
                <slot name="title"></slot>
            </p>
        </header>
        <article class="objective-section__content">
            <slot></slot>
        </article>
    </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.objective-section {
    &__header {
        padding-bottom: var(--spacing-1);
        border-bottom: 1px solid var(--colors-common-border-lighter);
        margin-bottom: var(--spacing-3);
    }

    &__title {
        display: flex;
        gap: var(--spacing-3);
        margin: 0;
        padding: var(--spacing-0) 0;
    }

    &__content {
        padding: 0px var(--spacing-6);
    }
}
</style>
